import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { Trad } from "src/components";
import { usePopupState, bindTrigger, bindMenu } from "material-ui-popup-state/hooks";
import { CopyType } from "./CommissionsForm";

const useStyles = makeStyles({
    addIcon: {
        float: "right"
    }
});

interface IContextMenuProps {
    OnCopyValues: (type: CopyType) => void;
}

export const _ContextMenu: React.FC<IContextMenuProps> = ({ OnCopyValues }) => {
    const classes = useStyles();
    const popupState = usePopupState({ variant: "popover", popupId: "contextMenu" });

    const onClickCopy = (type: CopyType): void => {
        OnCopyValues(type);
        popupState.close();
    };

    return (
        <>
            <IconButton aria-label="contextMenu" size="small" className={classes.addIcon} {...bindTrigger(popupState)}>
                <FileCopyIcon color="secondary" fontSize="small" />
            </IconButton>{" "}
            <Menu {...bindMenu(popupState)}>
                <MenuItem onClick={() => onClickCopy(CopyType.Branch)}>{Trad.Trad("Copy values")}</MenuItem>
                <MenuItem onClick={() => onClickCopy(CopyType.EmptyFields)}>{Trad.Trad("Copy to empty fields")}</MenuItem>
                <MenuItem onClick={() => onClickCopy(CopyType.Product)}>{Trad.Trad("Copy to the same product")}</MenuItem>
                <MenuItem onClick={() => onClickCopy(CopyType.Company)}>{Trad.Trad("Copy on the same company")}</MenuItem>
            </Menu>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/Commissions/ContextMenu.tsx